import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/customer`;

export default {
  // UpdateProfile(payload, paramId) {
  //   return Client.put(`${resource}/${paramId}`, {
  //     ...payload,
  //   })
  // },
  getProfile(paramId) {
    return Client.get(`${resource}/${paramId}`);
  },

  UpdateProfile(payload, paramId) {
    return Client.put(`${resource}/${paramId}`, {
      ...payload,
    });
  },
};
